/**
 * Catégories d'options dynamiques utilisées dans les champs "Autres"
 * du formulaire d'ajout de plainte.
 */
export enum DynamicOptionCategory {
  /** step3 – Lieu de l'incident (otherLocation) */
  INCIDENT_LOCATION = "INCIDENT_LOCATION",
  /** step4 – Institution ou structure mise en cause (INSTIT_IMP additionalInfo) */
  ACCUSED_INSTITUTION = "ACCUSED_INSTITUTION",
  /** step4 – Données anciennes (bucket générique, ne plus utiliser pour les nouvelles soumissions) */
  CLUSTER = "CLUSTER",
  /** step4 – Sous-natures de "Une accusation" (ACCUS additionalInfo) */
  ACCUSATION_SUBNATURE = "ACCUSATION_SUBNATURE",
  /** step4 – Sous-natures de "Nature du dysfonctionnement" (DYSFUNC_NAT additionalInfo) */
  DYSFUNC_SUBNATURE = "DYSFUNC_SUBNATURE",
  /** step4 – Sous-natures de "Réclamation" (CLAIM additionalInfo) */
  CLAIM_SUBNATURE = "CLAIM_SUBNATURE",

  // ── Profil / Agent externe ────────────────────────────────────────────────
  /** addProfile – Statut juridique autre (otherLegalStatus) */
  LEGAL_STATUS = "LEGAL_STATUS",
  /** addProfile – Branche concernée autre (otherConcernedBranches) */
  CONCERNED_BRANCHES = "CONCERNED_BRANCHES",
  /** addProfile – Type de partenariat autre (otherPartnershipType) */
  PARTNERSHIP_TYPE = "PARTNERSHIP_TYPE",
  /** addProfile – Document de référence autre (otherReferenceDocument) */
  REFERENCE_DOCUMENTS = "REFERENCE_DOCUMENTS",
  /** addProfile – Canal de remontée autre (otherReportingChannel) */
  INFORMATION_CHANNEL = "INFORMATION_CHANNEL",
  /** addProfile / plainte – Lien avec la victime */
  RELATIONSHIP_WITH_VICTIM = "RELATIONSHIP_WITH_VICTIM",
}

/**
 * Catégories connues et supportées par le backend (GET + POST fonctionnels).
 * Corresponds à l'enum backend Category :
 *   ReferenceDocuments, InformationChannel, PartnershipType, ConcernedBranches,
 *   LegalStatus, AccusedInstitution, Cluster, IncidentLocation, RelationshipWithVictim
 *
 * NON supportées (absent de l'enum backend) → causent un 500 :
 *   ACCUSATION_SUBNATURE, DYSFUNC_SUBNATURE, CLAIM_SUBNATURE
 */
export const BACKEND_SUPPORTED_CATEGORIES = new Set<DynamicOptionCategory>([
  DynamicOptionCategory.INCIDENT_LOCATION,
  DynamicOptionCategory.ACCUSED_INSTITUTION,
  DynamicOptionCategory.CLUSTER,
  DynamicOptionCategory.LEGAL_STATUS,
  DynamicOptionCategory.CONCERNED_BRANCHES,
  DynamicOptionCategory.PARTNERSHIP_TYPE,
  DynamicOptionCategory.REFERENCE_DOCUMENTS,
  DynamicOptionCategory.INFORMATION_CHANNEL,
  DynamicOptionCategory.RELATIONSHIP_WITH_VICTIM,
  // ❌ ACCUSATION_SUBNATURE   — absent de l'enum backend
  // ❌ DYSFUNC_SUBNATURE      — absent de l'enum backend
  // ❌ CLAIM_SUBNATURE        — absent de l'enum backend
]);

/** Corps d'une entrée dans le tableau POST /dynamic-option */
export interface DynamicOptionPostDTO {
  labelOriginal: string;
  category: DynamicOptionCategory | string;
  /** ID de la sous-nature liée. null si non applicable (ex. INCIDENT_LOCATION). */
  natureId: number | null;
}

/** Réponse 200 de POST /dynamic-option */
export interface DynamicOptionResponseDTO {
  id: number;
  labelNormalized: string;
  labelOriginal: string;
  occurrenceCount: number;
  createdAt: string;
  standardCreatedAt: string;
  standard: boolean;
}
